import { render, staticRenderFns } from "./section6.vue?vue&type=template&id=078943b9&scoped=true&"
import script from "./section6.vue?vue&type=script&lang=js&"
export * from "./section6.vue?vue&type=script&lang=js&"
import style0 from "./section6.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./section6.vue?vue&type=style&index=1&id=078943b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "078943b9",
  null
  
)

export default component.exports